import Reveal from "@/components/Reveal";
import CtaButton from "@/components/CtaButton";

const SECTIONS = [
    {
        title: "1. Maklumat yang Kami Kumpul",
        body: [
            "Apabila anda mengisi borang pendaftaran webinar, kami mengumpul: nama penuh, nombor telefon, alamat email (pilihan), tahap pengalaman trading anda dan hari webinar pilihan anda.",
            "Seperti kebanyakan laman web, kami juga menerima data teknikal asas daripada pelayar anda. Laman ini menggunakan Meta Pixel (Facebook) untuk mengukur prestasi iklan — sila rujuk bahagian Cookies & Pengiklanan di bawah.",
        ],
    },
    {
        title: "2. Cara Maklumat Digunakan",
        body: [
            "Maklumat anda digunakan semata-mata untuk menguruskan pendaftaran QOD Engulfing Newbie Onboard Webinar — termasuk komunikasi bersama admin mengenai penyertaan sesi Zoom dan pentadbiran berkaitan webinar.",
            "Kami tidak menjual atau menyewakan maklumat peribadi anda kepada mana-mana pihak ketiga.",
        ],
    },
    {
        title: "3. Penyimpanan & Akses Data",
        body: [
            "Pendaftaran disimpan dalam sistem backend penganjur yang selamat, dan mungkin disegerakkan ke Google Sheets penganjur untuk tujuan pentadbiran dalaman.",
            "Akses kepada data ini terhad kepada pasukan penganjur (Queen of Dollars) sahaja.",
        ],
    },
    {
        title: "4. Cookies & Pengiklanan",
        body: [
            "Laman ini menggunakan Meta Pixel untuk mengukur keberkesanan kempen Facebook — termasuk PageView, klik butang Telegram (TelegramClick) dan pendaftaran borang yang berjaya (CompleteRegistration).",
            "Data ini dikendalikan oleh Meta mengikut polisi privasi Meta. Anda boleh mengawal iklan yang diterima melalui tetapan iklan akaun Facebook anda.",
        ],
    },
    {
        title: "5. Hak Anda",
        body: [
            "Anda berhak meminta akses, pembetulan atau pemadaman maklumat pendaftaran anda pada bila-bila masa. Hubungi admin kami di Telegram dan kami akan proses secepat mungkin.",
            "Menarik balik persetujuan tidak menjejaskan pemprosesan yang telah dibuat sebelumnya.",
        ],
    },
    {
        title: "6. Perubahan Polisi",
        body: [
            "Polisi ini mungkin dikemas kini dari semasa ke semasa. Sebarang perubahan akan dipaparkan di halaman ini dengan tarikh kemas kini terkini.",
        ],
    },
];

const PrivacyPolicy = () => (
    <main className="relative mx-auto max-w-3xl px-4 pb-24 pt-32 sm:px-6 md:pt-40">
        <Reveal>
            <a
                href="#/"
                data-testid="privacy-back-link"
                className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-white/50 transition-colors duration-300 hover:text-white"
            >
                ← Kembali ke laman utama
            </a>
            <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.25em] text-neon">
                Legal
            </p>
            <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-white md:text-5xl">
                PRIVACY <span className="text-duo-grad">POLICY</span>
            </h1>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.18em] text-white/45">
                Kemas kini terakhir — 26 Oktober 2026
            </p>
            <p className="mt-8 leading-relaxed text-white/70">
                Polisi privasi ini menerangkan bagaimana Queen of Dollars (QOD)
                mengumpul, menggunakan dan melindungi maklumat anda apabila
                anda mendaftar QOD Engulfing Newbie Onboard Webinar.
            </p>
        </Reveal>

        <div className="mt-12 space-y-10">
            {SECTIONS.map((s, i) => (
                <Reveal key={s.title} delay={0.04 * i}>
                    <section
                        data-testid={`privacy-section-${i + 1}`}
                        className="border-l-2 border-white/10 pl-6"
                    >
                        <h2 className="font-display text-xl font-extrabold text-white md:text-2xl">
                            {s.title}
                        </h2>
                        <div className="mt-4 space-y-4">
                            {s.body.map((p, j) => (
                                <p
                                    key={j}
                                    className="text-sm leading-relaxed text-white/65 md:text-base"
                                >
                                    {p}
                                </p>
                            ))}
                        </div>
                    </section>
                </Reveal>
            ))}
        </div>

        <Reveal delay={0.1}>
            <div className="card-luxe mt-14 flex flex-col items-start gap-5 rounded-3xl p-8 md:flex-row md:items-center md:justify-between">
                <div>
                    <p className="font-display text-lg font-bold text-white">
                        Ada soalan tentang data anda?
                    </p>
                    <p className="mt-1 text-sm text-white/55">
                        PM admin kami terus di Telegram.
                    </p>
                </div>
                <CtaButton
                    location="Privacy Page"
                    testId="privacy-telegram-button"
                >
                    PM Admin to Join
                </CtaButton>
            </div>
        </Reveal>
    </main>
);

export default PrivacyPolicy;
